import ServerSettings, {ServerSettingsFieldType} from "../../gd/settings/server-settings/server-settings";

const fieldsConfig = {

    'errorLogs': {
        type            : ServerSettingsFieldType.BOOLEAN,
        defaultValue    : false,
    }
}

export default class UserSettings_Debug extends ServerSettings {

    public errorLogs   : boolean = false

    constructor(config: JSONObject) {
        super(config, fieldsConfig);

        this.errorLogs          = this.initValue('errorLogs')
    }

    toJson() {
        const result = {}
        this.valueToJson(result, 'errorLogs')

        return result
    }
}
